import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from '../components/StripePaymentForm';
import { useNavigate, useSearchParams } from 'react-router-dom';

// Initialize Stripe (you'll need to add your publishable key to environment variables)
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key');

interface PaymentPageProps {}

const PaymentPage: React.FC<PaymentPageProps> = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get payment details from URL params
  const registrationId = searchParams.get('registrationId');
  const clientSecret = searchParams.get('clientSecret');
  const amount = parseInt(searchParams.get('amount') || '0');
  const currency = searchParams.get('currency') || 'gbp';

  const handleSuccess = () => {
    navigate('/registration/success');
  };

  const handleCancel = () => {
    navigate('/business-registration');
  };

  if (!registrationId || !clientSecret) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Payment Error</h2>
        <p>Missing payment information. Please try registering again.</p>
        <button onClick={() => navigate('/business-registration')}>Back to Registration</button>
      </div>
    );
  }

  const paymentIntent = {
    id: 'temp', // We don't need this for confirmation
    client_secret: clientSecret,
    amount,
    currency
  };

  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe' as const,
    },
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <Elements stripe={stripePromise} options={options}>
        <StripePaymentForm
          paymentIntent={paymentIntent}
          registrationId={registrationId}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </Elements>
    </div>
  );
};

export default PaymentPage;